import { Component, OnDestroy } from '@angular/core';
import { AuthService } from './auth-module/services/auth.service';
import Swal from 'sweetalert2';
import { SpinnerHandlerService } from './admin/services/spinner.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // showLoader = true;
  loderSubs:any;
  private onlineStatus = true;
  constructor(private authService: AuthService,  public spinnerService:SpinnerHandlerService) {
  //  this.loderSubs = this.authService.showLoader.subscribe((response: boolean) => {    //Even calling admin APIs, but changing the showloader variable of auth Service in interceptor.
  //     console.log('loader response',response);
  //     this.showLoader = response;
  //   })
  this.detectOnlineStatus();
  }
  // ngOnDestroy(): void {
    // this.loderSubs?.unsubscribe();
  // }
  private detectOnlineStatus() {
    window.addEventListener('online', () => {
      this.onlineStatus = true;
      this.showOnlineAlert();
    });

    window.addEventListener('offline', () => {
      this.onlineStatus = false;
      this.showOfflineAlert();
    });
  }

  private showOnlineAlert() {
    Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: 'You are back Online!',
      timer: 3000,
      timerProgressBar: true,
      toast: true,
      position: 'top',
      showConfirmButton: false,
    });
  }

  private showOfflineAlert() {
    Swal.fire({

      icon: 'info',
      title: 'No Internet connection',
      text: 'Please check your internet connection and try again!',
      timer: 3000,
      timerProgressBar: true,
      toast: true,
      position: 'top',
      showConfirmButton: false,
    });
  }

  isOnline() {
    return this.onlineStatus;
  }
}
